<template>
  <div class="list-item" @click="onClick">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      onClick: Function
    }
  }
</script>

<style scoped>
  .list-item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    border-radius: 6px;
    color: #172329;
  }
  @media (hover: hover) {
    .list-item:hover {
      background: #ffffff;
      box-shadow: 0 4px 43px 9px rgba(0, 0, 0, 0.02);
      cursor: pointer;
    }
  }
</style>
